// Require Vue
window.Vue = require('vue').default;

import { createApp } from 'vue'
import MapComplaints from './components/Map/MapComplaints'

const app = createApp({})
app.component('map-complaints', MapComplaints)

app.mount('#app')
